/* LONELY · Recomendador de tallas · interfaz de 3 pasos
   Paso 1: estatura y peso · Paso 2: contextura, ajuste y medidas reales · Paso 3: talla.
   La recomendación automática solo aparece cuando la tabla del producto tiene datos validados
   (rangos de estatura/peso o holgura mínima por contorno). Si no, el cliente elige con las medidas reales. */
(function () {
  'use strict';
  if (customElements.get('lonely-size-finder')) return;
  var STORE = 'lonely_size_finder_v2';
  var ORDER = ['body', 'build', 'result'];
  var BUILDS = ['delgada', 'media', 'robusta'];
  var BUILD_W = { delgada: 0.84, media: 1, robusta: 1.2 };
  var FITS = ['ajustado', 'regular', 'oversize'];
  var LEN_KEYS = { largo: 'x_length' };
  /* Silueta atlética de frente (simétrica sobre x = 45, pies en y = 236). */
  var FIGURE = 'M40 25C40 29 39 31 36 32C30 33 24 34 20 37C15 39 12.5 44 12.5 51C12 58 11.5 64 11 70C10 76 9.5 80 9 86C8 94 7.5 102 7 110C6.5 116 6 120 6.5 124C6.5 130 8.5 134 11 133.5C13 133 13.5 128 13.5 124C14 118 15 112 16 104C17 96 18 90 19.5 84C20.5 78 21.5 74 22.5 70C23 66 23.5 62 24.5 59C25.5 70 27 80 28 90C29 98 28.5 104 27.5 110C26 118 25 124 25 132C24 146 25 158 27 170C27 176 26.5 180 27 186C26 196 25 206 27 216C28 222 28 226 28 230C26 232 24 234 25 236L37 236C38 233 37.5 230 37.5 228C38 218 39 206 38.5 194C38 188 39 184 39.5 180C40.5 168 42 152 43 140C43.5 136 44 134 45 133C46 134 46.5 136 47 140C48 152 49.5 168 50.5 180C51 184 52 188 51.5 194C51 206 52 218 52.5 228C52.5 230 52 233 53 236L65 236C66 234 64 232 62 230C62 226 62 222 63 216C65 206 64 196 63 186C63.5 180 63 176 63 170C65 158 66 146 65 132C65 124 64 118 62.5 110C61.5 104 61 98 62 90C63 80 64.5 70 65.5 59C66.5 62 67 66 67.5 70C68.5 74 69.5 78 70.5 84C72 90 73 96 74 104C75 112 76 118 76.5 124C76.5 128 77 133 79 133.5C81.5 134 83.5 130 83.5 124C84 120 83.5 116 83 110C82.5 102 82 94 81 86C80.5 80 80 76 79 70C78.5 64 78 58 77.5 51C77.5 44 75 39 70 37C66 34 60 33 54 32C51 31 50 29 50 25Z';
  var MUSCLES = 'M40.5 27.5C38.5 30.5 33 32.5 26 34.5M49.5 27.5C51.5 30.5 57 32.5 64 34.5' +
    'M36 36C39.5 37.2 42.5 37.6 45 37.4M54 36C50.5 37.2 47.5 37.6 45 37.4' +
    'M45 39V56' +
    'M28.5 43C35 50.5 41 50.5 45 46.5M61.5 43C55 50.5 49 50.5 45 46.5' +
    'M27 52C33 58 40 58.5 45 55M63 52C57 58 50 58.5 45 55' +
    'M45 59V101' +
    'M38.5 66.5C41 68 43 68 45 67C47 68 49 68 51.5 66.5' +
    'M38.5 76.5C41 78 43 78 45 77C47 78 49 78 51.5 76.5' +
    'M39 86.5C41 88 43 88 45 87C47 88 49 88 51 86.5' +
    'M39.5 96C41.5 98.5 43.5 99.5 45 99.5C46.5 99.5 48.5 98.5 50.5 96' +
    'M38.5 62C38 75 38.5 88 40 97M51.5 62C52 75 51.5 88 50 97' +
    'M33 61C35 80 38 96 45 107M57 61C55 80 52 96 45 107' +
    'M29.5 61.5L33 63.5M29.5 67L33.5 69M30 72.5L34 74.5M60.5 61.5L57 63.5M60.5 67L56.5 69M60 72.5L56 74.5' +
    'M20 39C22.5 45 24 51 24.5 58M70 39C67.5 45 66 51 65.5 58' +
    'M15.5 44C17 48 18.5 52 19 56M74.5 44C73 48 71.5 52 71 56' +
    'M14 60C17 65 19 71 19 79M76 60C73 65 71 71 71 79' +
    'M12 86C14 88 16.5 88.5 18.5 87M78 86C76 88 73.5 88.5 71.5 87' +
    'M11 92C12.5 98 13 104 13 110M79 92C77.5 98 77 104 77 110' +
    'M30.5 140C34 152 37.5 162 38.5 175M59.5 140C56 152 52.5 162 51.5 175' +
    'M34.5 133C36 147 36 160 34.5 173M55.5 133C54 147 54 160 55.5 173' +
    'M37.5 160C40 165.5 40.5 171 38.5 176M52.5 160C50 165.5 49.5 171 51.5 176' +
    'M30.5 178C33 182.5 36 182.5 38.5 178M59.5 178C57 182.5 54 182.5 51.5 178' +
    'M29.5 192C32 200 32 208 30 216M60.5 192C58 200 58 208 60 216' +
    'M36.5 194C35.5 202 35.5 208 36.5 214M53.5 194C54.5 202 54.5 208 53.5 214';


  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function fmt(s, map) {
    return String(s || '').replace(/\[(\w+)\]/g, function (m, k) { return map[k] != null ? map[k] : m; });
  }
  function round(n) { return Math.round(n * 10) / 10; }
  function num(n) { return String(round(n)).replace('.', ','); }
  function clamp(v, a, b) { return Math.min(b, Math.max(a, v)); }

  function figure(scaleX, scaleY, extra) {
    var sx = scaleX || 1;
    var sy = scaleY || 1;
    return '<svg viewBox="0 0 90 240" fill="none" class="lsf-fig">' +
      '<g class="lsf-fig__body" style="transform:scale(' + sx + ',' + sy + ')">' +
      '<path class="lsf-fig__s" d="' + FIGURE + '"/>' +
      '<ellipse class="lsf-fig__s" cx="45" cy="15" rx="8" ry="10.6"/>' +
      '<path class="lsf-fig__m" d="' + MUSCLES + '"/></g>' + (extra || '') + '</svg>';
  }

  class LonelySizeFinder extends HTMLElement {
    connectedCallback() {
      if (this._ready) return;
      this._ready = true;
      var core = window.LonelySizeCore;
      var cfgNode = this.querySelector('script[data-lsf-config]');
      if (!core || !cfgNode) return;
      this.core = core;
      this.cfg = JSON.parse(cfgNode.textContent);
      this.t = this.cfg.i18n;
      this.dialog = this.querySelector('dialog');
      this.lim = this.cfg.limits;
      this.body = {};
      this.build = null;
      this.fit = 'regular';
      this.chosen = {};
      this.step = 'body';
      var product = { options: this.cfg.options };
      this.guides = (this.cfg.guides || []).map(function (g) { return core.prepareGuide(g, product); });
      this.valid = this.guides.filter(function (g) { return g.valid; });
      this.patterns = {};
      this.restore();
      if (this.body.estatura == null) this.body.estatura = Math.round(clamp(170, this.lim.estatura[0], this.lim.estatura[1]));
      if (this.body.peso == null) this.body.peso = Math.round(clamp(70, this.lim.peso[0], this.lim.peso[1]));
      this.bind();
      /* Vista previa: ?encuentra-tu-talla=1 (o =2 / =3 para abrir en ese paso) o #encuentra-tu-talla */
      var q = new URLSearchParams(location.search).get('encuentra-tu-talla');
      if (q || /(^|[#&])encuentra-tu-talla/.test(location.hash)) {
        var self = this;
        var stepN = parseInt(q, 10) || 1;
        setTimeout(function () {
          self.open();
          if (!self.valid.length) return;
          if (stepN >= 2) self.show('build');
          if (stepN >= 3) { self.renderResult(); self.show('result'); }
        }, 50);
      }
    }

    bind() {
      var self = this;
      this.querySelector('[data-lsf-open]').addEventListener('click', function () { self.open(); });
      this.querySelectorAll('[data-lsf-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      this.dialog.addEventListener('click', function (e) { if (e.target === self.dialog) self.close(); });
      this.dialog.addEventListener('cancel', function (e) { e.preventDefault(); self.close(); });
      this.querySelector('[data-lsf-next]').addEventListener('click', function () { self.next(); });
      this.querySelector('[data-lsf-back]').addEventListener('click', function () { self.back(); });
      var consent = this.querySelector('[data-lsf-consent]');
      consent.checked = !!this.saved;
      consent.addEventListener('change', function () { if (!consent.checked) self.forget(); else self.persist(); });
      this.querySelector('[data-lsf-forget]').addEventListener('click', function () {
        consent.checked = false;
        self.forget();
        self.body = { estatura: 170, peso: 70 };
        self.build = null;
        self.renderBody();
      });
    }

    open() {
      this.lastFocus = document.activeElement;
      if (this.valid.length) {
        this.renderPatterns();
        this.renderBody();
        this.show('body');
      } else {
        this.renderFallback(this.t.not_configured_title);
        this.show('fallback');
      }
      document.documentElement.classList.add('lsf-lock');
      if (typeof this.dialog.showModal === 'function') this.dialog.showModal();
      else this.dialog.setAttribute('open', '');
      this.dialog.classList.add('is-open');
      var h = this.dialog.querySelector('.lsf-head h2');
      if (h) h.focus();
    }

    close() {
      var self = this;
      this.dialog.classList.remove('is-open');
      document.documentElement.classList.remove('lsf-lock');
      setTimeout(function () {
        if (self.dialog.open && typeof self.dialog.close === 'function') self.dialog.close();
        else self.dialog.removeAttribute('open');
        if (self.lastFocus && self.lastFocus.focus) self.lastFocus.focus();
      }, 220);
    }

    /* Guías activas: una por parte (superior / inferior); con dos patrones usa el elegido. */
    active() {
      var self = this;
      var byPart = {};
      this.valid.forEach(function (g) { (byPart[g.part] = byPart[g.part] || []).push(g); });
      var out = [];
      Object.keys(byPart).forEach(function (part) {
        var list = byPart[part];
        var chosen = self.patterns[part];
        out.push(list.filter(function (g) { return g.pattern === chosen; })[0] || list[0]);
      });
      return out.sort(function (a, b) { return (a.part === 'superior' ? 0 : 1) - (b.part === 'superior' ? 0 : 1); });
    }

    renderPatterns() {
      var self = this;
      var wrap = this.querySelector('[data-lsf-patterns]');
      wrap.innerHTML = '';
      var byPart = {};
      this.valid.forEach(function (g) { (byPart[g.part] = byPart[g.part] || []).push(g); });
      Object.keys(byPart).forEach(function (part) {
        var pats = byPart[part].map(function (g) { return g.pattern; }).filter(function (p, i, a) { return a.indexOf(p) === i; });
        if (pats.length < 2) return;
        if (!self.patterns[part]) self.patterns[part] = pats[0];
        var fs = el('fieldset', 'lsf-seg');
        fs.appendChild(el('legend', 'lsf-label', self.t.pattern_label + (Object.keys(byPart).length > 1 ? ' · ' + self.t['part_' + part] : '')));
        var row = el('div', 'lsf-seg__row');
        pats.forEach(function (p) {
          row.appendChild(self.choice('lsf-pat-' + part, p, self.t['pattern_' + p] || p, self.patterns[part] === p, function () { self.patterns[part] = p; }));
        });
        fs.appendChild(row);
        wrap.appendChild(fs);
      });
      wrap.hidden = !wrap.children.length;
    }

    choice(name, value, label, checked, onChange, cls) {
      var id = this.dialog.id + '-' + name + '-' + value;
      var w = el('div', cls || 'lsf-chip');
      var input = el('input');
      input.type = 'radio';
      input.name = this.dialog.id + '-' + name;
      input.id = id;
      input.value = value;
      input.checked = !!checked;
      input.addEventListener('change', onChange);
      var lab = el('label');
      lab.htmlFor = id;
      if (typeof label === 'string') lab.textContent = label;
      else lab.appendChild(label);
      w.appendChild(input);
      w.appendChild(lab);
      return w;
    }

    /* ---------- Controles numéricos con − / + y deslizador ---------- */
    stepper(def) {
      var self = this;
      var id = this.dialog.id + '-' + def.key;
      var row = el('div', 'lsf-field');
      row.dataset.key = def.key;
      var top = el('div', 'lsf-field__top');
      var lab = el('label', 'lsf-label', def.label);
      lab.htmlFor = id;
      top.appendChild(lab);
      if (def.tag) top.appendChild(el('span', 'lsf-tag' + (def.req ? ' lsf-tag--req' : ''), def.tag));
      row.appendChild(top);
      var ctl = el('div', 'lsf-ctl');
      var minus = el('button', 'lsf-step', '−');
      minus.type = 'button';
      minus.setAttribute('aria-label', this.t.decrease + ' ' + def.label);
      var plus = el('button', 'lsf-step', '+');
      plus.type = 'button';
      plus.setAttribute('aria-label', this.t.increase + ' ' + def.label);
      var box = el('div', 'lsf-num');
      var input = el('input');
      input.type = 'number';
      input.id = id;
      input.inputMode = 'decimal';
      input.min = def.min;
      input.max = def.max;
      input.step = def.step;
      input.placeholder = '—';
      input.setAttribute('aria-describedby', id + '-msg');
      box.appendChild(input);
      box.appendChild(el('span', 'lsf-unit', def.unit));
      ctl.appendChild(minus);
      ctl.appendChild(box);
      ctl.appendChild(plus);
      row.appendChild(ctl);
      var range = el('input', 'lsf-range');
      range.type = 'range';
      range.min = def.min;
      range.max = def.max;
      range.step = def.step;
      range.tabIndex = -1;
      range.setAttribute('aria-hidden', 'true');
      row.appendChild(range);
      var msg = el('p', 'lsf-msg', def.help || '');
      msg.id = id + '-msg';
      row.appendChild(msg);

      function paint() {
        var v = self.body[def.key];
        input.value = v != null ? v : '';
        range.value = v != null ? v : (def.min + def.max) / 2;
        range.classList.toggle('is-empty', v == null);
        range.style.setProperty('--lsf-pct', (((v != null ? v : def.min) - def.min) / (def.max - def.min)) * 100 + '%');
      }
      function set(v, strict) {
        if (v === '' || v == null || isNaN(v)) {
          delete self.body[def.key];
          row.classList.remove('is-invalid');
          msg.textContent = def.help || '';
        } else if (v < def.min || v > def.max) {
          if (!strict) return;
          row.classList.add('is-invalid');
          msg.textContent = fmt(self.t.invalid_range, { min: def.min, max: def.max, unit: def.unit });
          paint();
          return;
        } else {
          self.body[def.key] = round(v);
          row.classList.remove('is-invalid');
          msg.textContent = def.help || '';
        }
        paint();
        self.persist();
        if (def.onChange) def.onChange();
      }
      input.addEventListener('change', function () { set(input.value === '' ? null : parseFloat(String(input.value).replace(',', '.')), true); });
      range.addEventListener('input', function () { set(parseFloat(range.value)); });
      function bump(dir) {
        var cur = self.body[def.key];
        cur = cur == null ? Math.round((def.min + def.max) / 2) : cur + dir * def.step;
        set(clamp(cur, def.min, def.max));
      }
      var hold;
      function startHold(dir) {
        bump(dir);
        hold = setTimeout(function rep() { bump(dir); hold = setTimeout(rep, 70); }, 420);
      }
      function stopHold() { clearTimeout(hold); }
      [[minus, -1], [plus, 1]].forEach(function (p) {
        p[0].addEventListener('pointerdown', function (e) { e.preventDefault(); startHold(p[1]); });
        ['pointerup', 'pointerleave', 'pointercancel'].forEach(function (ev) { p[0].addEventListener(ev, stopHold); });
        p[0].addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bump(p[1]); } });
      });
      paint();
      return row;
    }

    /* ---------- Paso 1 · Estatura y peso ---------- */
    renderBody() {
      var self = this;
      var wrap = this.querySelector('[data-lsf-body-fields]');
      wrap.innerHTML = '';
      var update = function () { self.paintSilhouette(); };
      wrap.appendChild(this.stepper({ key: 'estatura', label: this.t.x_height, unit: 'cm', min: this.lim.estatura[0], max: this.lim.estatura[1], step: 1, onChange: update }));
      wrap.appendChild(this.stepper({ key: 'peso', label: this.t.x_weight, unit: 'kg', min: this.lim.peso[0], max: this.lim.peso[1], step: 0.5, onChange: update }));
      this.querySelector('[data-lsf-forget]').hidden = !this.saved;
      var bodyView = this.querySelector('[data-lsf-view="body"]');
      if (!bodyView.querySelector('.lsf-guide')) bodyView.appendChild(this.guideLink());
      this.paintSilhouette(true);
    }

    bodyScale() {
      var h = this.body.estatura || 170;
      var w = this.body.peso || 70;
      var sy = 0.84 + ((h - this.lim.estatura[0]) / (this.lim.estatura[1] - this.lim.estatura[0])) * 0.16;
      var bmi = w / Math.pow(h / 100, 2);
      var sx = clamp(0.78 + (clamp(bmi, 16, 40) - 16) / 24 * 0.6, 0.78, 1.38);
      return { x: round(sx * 100) / 100, y: round(sy * 100) / 100 };
    }

    paintSilhouette(fresh) {
      var host = this.querySelector('[data-lsf-sil]');
      var s = this.bodyScale();
      if (fresh || !host.firstChild) {
        host.innerHTML = figure(s.x, s.y,
          '<line class="lsf-fig__h" x1="86" y1="6" x2="86" y2="232"/>' +
          '<text class="lsf-fig__v" data-v="h" x="84" y="2" text-anchor="end"></text>' +
          '<text class="lsf-fig__v" data-v="w" x="45" y="250" text-anchor="middle"></text>');
        host.querySelector('svg').setAttribute('viewBox', '0 -8 90 262');
      }
      var g = host.querySelector('.lsf-fig__body');
      g.style.transform = 'scale(' + s.x + ',' + s.y + ')';
      host.querySelector('[data-v="h"]').textContent = (this.body.estatura != null ? this.body.estatura : '—') + ' cm';
      host.querySelector('[data-v="w"]').textContent = (this.body.peso != null ? num(this.body.peso) : '—') + ' kg';
    }

    /* ---------- Paso 2 · Contextura, ajuste y medidas reales ---------- */
    renderBuild() {
      var self = this;
      var t = this.t;
      var bw = this.querySelector('[data-lsf-builds]');
      bw.innerHTML = '';
      var s = this.bodyScale();
      BUILDS.forEach(function (b) {
        var lab = el('span', 'lsf-build__in');
        var fig = el('span', 'lsf-build__fig');
        fig.innerHTML = figure(round(BUILD_W[b] * 100) / 100, 1);
        fig.setAttribute('aria-hidden', 'true');
        lab.appendChild(fig);
        lab.appendChild(el('span', 'lsf-build__name', t['x_build_' + b]));
        lab.appendChild(el('span', 'lsf-build__desc', t['x_build_' + b + '_desc']));
        bw.appendChild(self.choice('build', b, lab, self.build === b, function () { self.build = b; self.persist(); }, 'lsf-build'));
      });

      var guides = this.active();
      var allow = {
        ajustado: guides.some(function (g) { return g.allowTight; }),
        regular: guides.some(function (g) { return g.allowRegular; }),
        oversize: guides.some(function (g) { return g.allowOversize; })
      };
      var configured = guides.some(function (g) { return g.canRecommend; });
      var fw = this.querySelector('[data-lsf-fits]');
      fw.innerHTML = '';
      FITS.forEach(function (f) {
        var lab = el('span', 'lsf-fit__in');
        lab.appendChild(el('span', 'lsf-fit__name', t['fit_' + f]));
        lab.appendChild(el('span', 'lsf-fit__desc', t['fit_' + f + '_desc']));
        if (configured && !allow[f]) lab.appendChild(el('span', 'lsf-fit__note', t.fit_not_available));
        fw.appendChild(self.choice('fit', f, lab, self.fit === f, function () { self.fit = f; self.persist(); }, 'lsf-fit'));
      });

      /* Medidas corporales reales: solo las que la tabla puede comparar. */
      var keys = [];
      var required = {};
      guides.forEach(function (g) {
        g.table.rows.forEach(function (r) { Object.keys(r.circ).forEach(function (k) { if (keys.indexOf(k) < 0) keys.push(k); }); });
        if (g.modeB || (self.cfg.admin && g.previewable && g.bReady)) g.measureKeys.forEach(function (k) { required[k] = true; });
      });
      var extra = this.querySelector('[data-lsf-extra]');
      var ew = this.querySelector('[data-lsf-extra-fields]');
      ew.innerHTML = '';
      this.core.CIRC.forEach(function (k) {
        if (keys.indexOf(k) < 0) return;
        var label = k === 'pecho' ? t.x_chest : t['f_' + k];
        ew.appendChild(self.stepper({
          key: k, label: label, unit: 'cm', min: self.lim[k][0], max: self.lim[k][1], step: 0.5,
          req: !!required[k], tag: required[k] ? t.required : t.optional,
          help: (k === 'pecho' ? t.x_chest_help : t.measure_help) + ' ' + (required[k] ? '' : t.x_chest_why)
        }));
      });
      extra.hidden = !ew.children.length;
    }

    missingRequired() {
      var self = this;
      return Array.prototype.filter.call(this.querySelectorAll('[data-lsf-extra-fields] .lsf-field'), function (row) {
        return row.querySelector('.lsf-tag--req') && self.body[row.dataset.key] == null;
      });
    }

    /* ---------- Navegación ---------- */
    show(view) {
      var prev = this.step;
      this.step = view;
      var idx = ORDER.indexOf(view);
      var dir = ORDER.indexOf(view) >= ORDER.indexOf(prev) ? 'fwd' : 'back';
      this.querySelectorAll('[data-lsf-view]').forEach(function (s) {
        var on = s.dataset.lsfView === view;
        s.hidden = !on;
        if (on) {
          s.classList.remove('is-in-fwd', 'is-in-back');
          void s.offsetWidth;
          s.classList.add(dir === 'fwd' ? 'is-in-fwd' : 'is-in-back');
        }
      });
      var steps = this.querySelector('[data-lsf-steps]');
      steps.hidden = idx < 0;
      steps.querySelectorAll('li').forEach(function (li, i) {
        li.classList.toggle('is-current', i === idx);
        li.classList.toggle('is-done', idx > -1 && i < idx);
        if (i === idx) li.setAttribute('aria-current', 'step');
        else li.removeAttribute('aria-current');
      });
      var back = this.querySelector('[data-lsf-back]');
      var next = this.querySelector('[data-lsf-next]');
      back.hidden = view === 'body' || (view === 'fallback' && !this.valid.length);
      back.textContent = view === 'result' ? this.t.x_restart : this.t.back;
      next.hidden = view === 'result' || view === 'fallback';
      next.textContent = view === 'build' ? this.t.see_result : this.t.next;
      this.querySelector('.lsf-foot').classList.toggle('is-single', next.hidden || back.hidden);
      this.querySelector('.lsf-scroll').scrollTop = 0;
      if (view === 'build') this.renderBuild();
    }

    next() {
      if (this.step === 'body') {
        if (this.body.estatura == null || this.body.peso == null) {
          var f = this.querySelector('[data-lsf-body-fields] input[type="number"]');
          if (f) f.focus();
          return;
        }
        this.show('build');
      } else if (this.step === 'build') {
        var self = this;
        var missing = this.missingRequired();
        if (missing.length) {
          missing.forEach(function (row) {
            row.classList.add('is-invalid');
            row.querySelector('.lsf-msg').textContent = self.t.x_chest_need;
          });
          missing[0].querySelector('input[type="number"]').focus();
          return;
        }
        this.renderResult();
        this.show('result');
      }
    }

    back() {
      if (this.step === 'build') this.show('body');
      else if (this.step === 'result') this.show('build');
      else if (this.step === 'fallback') this.show(this.fbReturn || 'result');
    }

    /* ---------- Paso 3 · Resultado ---------- */
    renderResult() {
      var self = this;
      var t = this.t;
      var box = this.querySelector('[data-lsf-result]');
      box.innerHTML = '';
      var guides = this.active();
      this.results = guides.map(function (g, gi) {
        var r = self.core.recommend(g, self.body, self.fit, { preview: !!self.cfg.admin });
        var key = g.part + gi;
        if (r.status === 'ok') self.chosen[key] = r.index;
        else if (self.chosen[key] == null) {
          var cur = self.currentOptions()[g.optionIndex];
          var i = g.sizes.map(function (s) { return s.optionValue; }).indexOf(cur);
          self.chosen[key] = i > -1 && self.hadSize ? i : null;
        }
        /* Stock real de cada talla en la combinación elegida (color, etc.). */
        var inStock = [];
        g.sizes.forEach(function (s, i) {
          var v = self.variantFor(g, s);
          if (v && v.available) inStock.push(i);
        });
        var only = g.sizes.length > 1 && inStock.length === 1 ? inStock[0] : null;
        var onlyFits = only != null && (r.status !== 'ok' && r.status !== 'nofit' ? true : r.compatible.indexOf(only) > -1);
        /* Si solo queda una talla y la recomendada (o ninguna) no está disponible, preselecciona la única en stock si es compatible. */
        if (only != null && onlyFits && (r.status !== 'ok' || r.index !== only)) self.chosen[key] = only;
        return { g: g, r: r, key: key, inStock: inStock, only: only, onlyFits: onlyFits };
      });

      /* Perfil del cliente */
      var prof = el('div', 'lsf-profile');
      prof.appendChild(el('p', 'lsf-label', t.x_profile));
      var pl = el('p', 'lsf-profile__line');
      var bits = [this.body.estatura + ' cm', num(this.body.peso) + ' kg'];
      if (this.build) bits.push(t['x_build_' + this.build]);
      bits.push(t['fit_' + this.fit]);
      if (this.body.pecho != null) bits.push(t.k_pecho + ' ' + num(this.body.pecho) + ' cm');
      pl.textContent = bits.join(' · ');
      prof.appendChild(pl);
      box.appendChild(prof);

      this.results.forEach(function (x) { box.appendChild(self.resultCard(x, guides.length > 1)); });

      var actions = el('div', 'lsf-actions');
      var btn = el('button', 'lsf-btn lsf-btn--primary lsf-select', this.cfg.select_label);
      btn.type = 'button';
      btn.addEventListener('click', function () { self.applySelection(); });
      actions.appendChild(btn);
      var status = el('p', 'lsf-status');
      status.setAttribute('role', 'status');
      actions.appendChild(status);
      actions.appendChild(this.guideLink());
      box.appendChild(actions);
      if (this.cfg.disclaimer) box.appendChild(el('p', 'lsf-disclaimer', this.cfg.disclaimer));
      this.paintSelect();
    }

    resultCard(x, multi) {
      var self = this;
      var t = this.t;
      var g = x.g;
      var r = x.r;
      var card = el('div', 'lsf-res');
      card.dataset.key = x.key;
      if (multi) card.appendChild(el('p', 'lsf-res__part', t['part_' + g.part]));

      card.appendChild(this.hero(x));

      /* Selector de tallas S · M · L · XL */
      var fs = el('fieldset', 'lsf-sizes');
      fs.appendChild(el('legend', 'lsf-label', t.x_sizes));
      var row = el('div', 'lsf-sizes__row');
      g.sizes.forEach(function (s, i) {
        var v = self.variantFor(g, s);
        var lab = el('span', 'lsf-size__in');
        lab.appendChild(el('span', 'lsf-size__name', s.size));
        var st = !v ? t.combo_missing : !v.available ? t.sold_out : '';
        var computed = r.status === 'ok' || r.status === 'nofit';
        var compat = computed && r.compatible.indexOf(i) > -1;
        if (computed) lab.appendChild(el('span', 'lsf-size__fit', compat ? t.x_compat_tag : t.x_incompat_tag));
        if (st) lab.appendChild(el('span', 'lsf-size__st', st));
        var c = self.choice('size-' + x.key, String(i), lab, self.chosen[x.key] === i, function () {
          self.chosen[x.key] = i;
          self.paintDetail(card, x);
          self.paintSelect();
        }, 'lsf-size' + (r.status === 'ok' && r.index === i ? ' is-rec' : '') + (computed ? (compat ? ' is-compat' : ' is-incompat') : '') + (st ? ' is-out' : ''));
        row.appendChild(c);
      });
      fs.appendChild(row);
      card.appendChild(fs);

      var detail = el('div', 'lsf-detail');
      card.appendChild(detail);
      this.paintDetail(card, x);

      card.appendChild(this.table(g, x));
      if (g.raw.nota) card.appendChild(el('p', 'lsf-note', g.raw.nota));
      return card;
    }

    /* Resultado principal: talla recomendada con su explicación, o selección manual si faltan reglas. */
    hero(x) {
      var self = this;
      var t = this.t;
      var g = x.g;
      var r = x.r;
      var ease = g.table.ease;
      var hero = el('div', 'lsf-hero');
      var fitName = function (f) { return t['fit_' + f].toLowerCase(); };
      if (r.preview) hero.appendChild(el('p', 'lsf-preview-badge', t.x_preview_badge));
      if (r.status === 'ok') {
        hero.appendChild(el('p', 'lsf-label lsf-hero__label', t.x_rec));
        hero.appendChild(el('p', 'lsf-hero__size', r.size.size));
        var recV = this.variantFor(g, r.size);
        if (!recV || !recV.available) {
          var altV = r.alt ? this.variantFor(g, r.alt.row) : null;
          var stockMsg = fmt(recV ? t.x_rec_sold_out : t.x_rec_missing, { size: r.size.size });
          if (altV && altV.available) stockMsg += ' ' + fmt(t.x_rec_sold_out_alt, { size: r.alt.row.size });
          hero.appendChild(el('p', 'lsf-warn lsf-warn--stock', stockMsg));
        }
        if (r.mode === 'B') {
          r.used.forEach(function (k) {
            var gv = r.size.circ[k];
            if (gv == null) return;
            var flat = r.size.values[k + '_plano'];
            var dl = el('dl', 'lsf-calc');
            var line = function (label, value, strong) {
              var row = el('div', 'lsf-calc__row' + (strong ? ' is-strong' : ''));
              row.appendChild(el('dt', null, label));
              row.appendChild(el('dd', null, value));
              dl.appendChild(row);
            };
            var e = gv - self.body[k];
            line(fmt(t.x_calc_body, { key: t['k_' + k] }), num(self.body[k]) + ' cm');
            line(fmt(t.x_calc_garment, { size: r.size.size }), (flat != null ? num(flat) + ' × 2 = ' : '') + num(gv) + ' cm');
            line(t.x_calc_ease, (e >= 0 ? '+' : '−') + num(Math.abs(e)) + ' cm', true);
            line(t.x_calc_fit, (g.raw.corte || t['fit_' + r.fitUsed]) + (r.targetSrc === 'pref' ? ' · ' + t['fit_' + r.fitUsed] : ''));
            line(t.x_calc_range, num(ease.min[k]) + (ease.max[k] != null ? '–' + num(ease.max[k]) : '+') + ' cm' + (r.target && r.target[k] != null ? ' · ' + fmt(t.x_calc_target, { v: num(r.target[k]) }) : ''));
            hero.appendChild(dl);
            hero.appendChild(el('p', 'lsf-basis', r.target && r.target[k] != null ? fmt(t.x_why_closest, { size: r.size.size }) : fmt(t.x_why_first, { size: r.size.size })));
          });
          if (r.length) hero.appendChild(el('p', r.length === 'ok' ? 'lsf-basis' : 'lsf-warn', t['x_len_' + r.length]));
        } else {
          hero.appendChild(el('p', 'lsf-basis', t.basis_ranges));
        }
        if (r.alt) {
          var altBox = el('div', 'lsf-alt');
          var k0 = r.used[0];
          var altE = k0 && r.alt.row.circ[k0] != null ? r.alt.row.circ[k0] - self.body[k0] : null;
          altBox.appendChild(el('p', 'lsf-basis', fmt(altE != null ? t.x_alt_line : t.x_alt_plain, { size: r.alt.row.size, ease: altE != null ? (altE >= 0 ? '+' : '−') + num(Math.abs(altE)) : '' })));
          var cmpBtn = el('button', 'lsf-btn lsf-btn--ghost lsf-alt__btn', fmt(t.x_alt_compare, { size: r.alt.row.size }));
          cmpBtn.type = 'button';
          cmpBtn.addEventListener('click', function () {
            var card = hero.closest('.lsf-res');
            var inp = card.querySelectorAll('.lsf-size input')[r.alt.index];
            if (inp) { inp.checked = true; inp.dispatchEvent(new Event('change', { bubbles: true })); }
          });
          altBox.appendChild(cmpBtn);
          hero.appendChild(altBox);
        }
        hero.appendChild(el('p', 'lsf-basis lsf-compat-line', fmt(t.x_compat, { list: r.compatible.map(function (i) { return g.sizes[i].size; }).join(', ') })));
        r.warnings.forEach(function (w) {
          var txt = w === 'fit_not_allowed' ? fmt(t.warn_fit_not_allowed, { fit: fitName(self.fit) })
            : w === 'no_target' ? fmt(t.warn_no_target, { fit: fitName(r.fitUsed) })
            : w === 'ranges_overlap' ? fmt(t.warn_ranges_overlap, { list: r.compatible.map(function (i) { return g.sizes[i].size; }).join(', ') })
            : t['warn_' + w];
          if (txt) hero.appendChild(el('p', 'lsf-warn', txt));
        });
      } else {
        hero.classList.add('is-manual');
        hero.appendChild(el('p', 'lsf-hero__title', t.x_manual_title));
        var msg = r.status === 'need' ? fmt(t.need_measure, { key: t['f_' + r.need] || t.f_estatura_peso })
          : r.status === 'nofit' ? (r.warnings.indexOf('outside_ranges') > -1 ? t.warn_outside_ranges : r.warnings.indexOf('none_in_range') > -1 ? t.warn_none_in_range : t.warn_none_fits)
          : t.x_manual_text;
        hero.appendChild(el('p', 'lsf-basis', msg));
        if (r.status === 'nofit' && r.mode === 'B') {
          var mk = r.used[0];
          hero.appendChild(el('p', 'lsf-basis', t.x_calc_range + ': ' + num(ease.min[mk]) + (ease.max[mk] != null ? '–' + num(ease.max[mk]) : '+') + ' cm'));
        }
      }
      /* Aviso solo para el administrador (editor de temas). */
      if (this.cfg.admin && g.missing && g.missing.length) {
        var adm = el('div', 'lsf-admin');
        adm.appendChild(el('p', 'lsf-label', t.x_admin_title));
        g.missing.forEach(function (m) { adm.appendChild(el('p', 'lsf-basis', fmt(t['x_admin_' + m] || m, { name: g.name }))); });
        hero.appendChild(adm);
      }
      /* Aviso de stock: una sola talla disponible o todas agotadas. */
      if (x.inStock && g.sizes.length > 1) {
        var msgStock = null;
        if (!x.inStock.length) msgStock = t.x_stock_none;
        else if (x.only != null) {
          var o = g.sizes[x.only].size;
          if (r.status === 'ok' && r.index === x.only) msgStock = fmt(t.x_stock_only_rec, { size: o });
          else if (r.status === 'ok') msgStock = fmt(x.onlyFits ? t.x_stock_only_alt : t.x_stock_only_nofit, { size: o, rec: r.size.size });
          else if (r.status === 'nofit') msgStock = fmt(t.x_stock_only_nofit2, { size: o });
          else msgStock = fmt(t.x_stock_only, { size: o });
        }
        if (msgStock) hero.appendChild(el('p', 'lsf-stock-note', msgStock));
      }
      return hero;
    }

    paintDetail(card, x) {
      var self = this;
      var t = this.t;
      var g = x.g;
      var d = card.querySelector('.lsf-detail');
      d.innerHTML = '';
      card.querySelectorAll('.lsf-table tbody tr').forEach(function (tr, i) { tr.classList.toggle('is-sel', self.chosen[x.key] === i); });
      var i = this.chosen[x.key];
      if (i == null) {
        d.appendChild(el('p', 'lsf-hint', t.x_pick_size));
        return;
      }
      var s = g.sizes[i];
      d.appendChild(el('p', 'lsf-cmp__title', fmt(t.garment_measures, { size: s.size })));
      var grid = el('dl', 'lsf-metrics');
      function metric(label, value, sub) {
        var m = el('div', 'lsf-metric');
        m.appendChild(el('dt', null, label));
        var dd = el('dd', null, value);
        m.appendChild(dd);
        if (sub) m.appendChild(el('p', 'lsf-metric__sub', sub));
        grid.appendChild(m);
      }
      g.table.columns.forEach(function (c) {
        var v = s.values[c.key];
        if (v == null || c.type === 'range') return;
        if (c.type === 'circ') {
          var flatLabel = c.body === 'pecho' ? t.x_chest_flat : t['k_' + c.body] + (c.factor === 2 ? ' (' + t.flat + ')' : ' (' + t.circ + ')');
          metric(flatLabel, num(v) + ' cm', c.factor === 2 ? (c.body === 'pecho' ? t.x_chest_circ : t.circ) + ': ' + num(v * 2) + ' cm' : null);
        } else {
          metric(t[LEN_KEYS[c.key]] || t['k_' + c.key] || c.key.replace(/_/g, ' '), num(v) + ' cm');
        }
      });
      d.appendChild(grid);

      /* Comparación real: contorno de la prenda frente al contorno del cliente. */
      var cmp = el('div', 'lsf-cmp');
      Object.keys(s.circ).forEach(function (k) {
        var bv = self.body[k];
        if (bv == null) return;
        var gv = s.circ[k];
        var ease = round(gv - bv);
        var max = Math.max(gv, bv) * 1.06;
        var bar = el('div', 'lsf-bar');
        var head = el('div', 'lsf-bar__head');
        head.appendChild(el('span', null, t['k_' + k]));
        head.appendChild(el('span', 'lsf-bar__ease', (ease >= 0 ? '+' : '−') + num(Math.abs(ease)) + ' cm ' + t.ease.toLowerCase()));
        bar.appendChild(head);
        var track = el('div', 'lsf-bar__track');
        track.setAttribute('aria-hidden', 'true');
        var garm = el('span', 'lsf-bar__garment');
        var body = el('span', 'lsf-bar__body');
        track.appendChild(garm);
        track.appendChild(body);
        bar.appendChild(track);
        bar.appendChild(el('p', 'lsf-bar__legend', t.body + ' ' + num(bv) + ' cm · ' + t.garment + ' ' + num(gv) + ' cm'));
        requestAnimationFrame(function () {
          garm.style.width = (gv / max) * 100 + '%';
          body.style.width = (bv / max) * 100 + '%';
        });
        cmp.appendChild(bar);
        if (k === 'pecho') cmp.appendChild(el('p', 'lsf-explain', fmt(ease >= 0 ? t.x_ease_line : t.x_ease_tight, { size: s.size, ease: num(Math.abs(ease)) })));
      });
      if (cmp.children.length) d.appendChild(cmp);

      var ex = [];
      if (g.raw.corte) ex.push(fmt(t.x_cut, { cut: g.raw.corte }));
      ex.push(fmt(t.x_fit_pref, { fit: t['fit_' + this.fit].toLowerCase() }));
      d.appendChild(el('p', 'lsf-explain', ex.join(' ')));
      if (g.table.columns.some(function (c) { return c.type === 'circ' && c.factor === 2; })) d.appendChild(el('p', 'lsf-hint', t.x_flat_note));
      var v = this.variantFor(g, s);
      d.appendChild(this.stockBadge(v));
    }

    table(g, x) {
      var self = this;
      var t = this.t;
      var cols = g.table.columns.filter(function (c) { return c.type !== 'range'; });
      var wrap = el('div', 'lsf-table-wrap');
      wrap.setAttribute('tabindex', '0');
      var table = el('table', 'lsf-table');
      table.appendChild(el('caption', null, t.x_all_sizes));
      var thead = el('thead');
      var tr = el('tr');
      var th0 = el('th', null, t.size);
      th0.scope = 'col';
      tr.appendChild(th0);
      cols.forEach(function (c) {
        var name = c.type === 'circ' ? (c.body === 'pecho' && c.factor === 2 ? t.x_chest_flat : t['k_' + c.body] + ' (' + (c.factor === 2 ? t.flat : t.circ) + ')') : (t[LEN_KEYS[c.key]] || t['k_' + c.key] || c.key.replace(/_/g, ' '));
        var th = el('th', null, name);
        th.scope = 'col';
        tr.appendChild(th);
      });
      /* Columna de holgura real por talla cuando el cliente dio su contorno. */
      var easeKeys = (g.comparableKeys || []).filter(function (k) { return self.body && self.body[k] != null; });
      easeKeys.forEach(function (k) {
        var th = el('th', null, fmt(t.x_ease_col, { key: t['k_' + k] }));
        th.scope = 'col';
        tr.appendChild(th);
      });
      thead.appendChild(tr);
      table.appendChild(thead);
      var tb = el('tbody');
      g.sizes.forEach(function (s, i) {
        var row = el('tr', self.chosen[x.key] === i ? 'is-sel' : null);
        var th = el('th', null, s.size);
        th.scope = 'row';
        row.appendChild(th);
        cols.forEach(function (c) { row.appendChild(el('td', null, s.values[c.key] != null ? num(s.values[c.key]) : '—')); });
        easeKeys.forEach(function (k) {
          var e = s.circ[k] != null ? s.circ[k] - self.body[k] : null;
          var td = el('td', 'lsf-td-ease', e == null ? '—' : (e >= 0 ? '+' : '−') + num(Math.abs(e)));
          if (e != null && g.table.ease.min[k] != null) td.classList.add(e >= g.table.ease.min[k] ? 'is-ok' : 'is-low');
          row.appendChild(td);
        });
        tb.appendChild(row);
      });
      table.appendChild(tb);
      wrap.appendChild(table);
      return wrap;
    }

    paintSelect() {
      var btn = this.querySelector('.lsf-select');
      if (!btn) return;
      var self = this;
      var picks = (this.results || []).filter(function (x) { return self.chosen[x.key] != null; });
      var sizes = picks.map(function (x) { return x.g.sizes[self.chosen[x.key]].size; });
      btn.textContent = this.cfg.select_label + (sizes.length ? ' · ' + sizes.join(' / ') : '');
      btn.setAttribute('aria-disabled', picks.length ? 'false' : 'true');
      btn.classList.toggle('is-disabled', !picks.length);
    }

    applySelection() {
      var self = this;
      var status = this.querySelector('.lsf-status');
      var picks = (this.results || []).filter(function (x) { return self.chosen[x.key] != null; });
      if (!picks.length) {
        status.textContent = this.t.x_choose_first;
        return;
      }
      var p = this.picker();
      if (!p) {
        status.textContent = this.t.no_picker;
        return;
      }
      picks.forEach(function (x) { self.applyOption(p, x.g.optionIndex, x.g.sizes[self.chosen[x.key]].optionValue); });
      this.hadSize = true;
      status.textContent = fmt(this.t.selected, { size: picks.map(function (x) { return x.g.sizes[self.chosen[x.key]].size; }).join(' / ') });
      setTimeout(function () { self.close(); }, 1100);
    }

    stockBadge(v) {
      var b = el('p', 'lsf-stock');
      if (!v) { b.classList.add('is-out'); b.textContent = this.t.combo_missing; }
      else if (!v.available) { b.classList.add('is-out'); b.textContent = this.t.sold_out; }
      else b.textContent = this.t.in_stock;
      return b;
    }

    /* ---------- Integración con el selector de variantes del tema ---------- */
    variantFor(g, row) {
      var sel = this.currentOptions();
      sel[g.optionIndex] = row.optionValue;
      return this.liveVariants().filter(function (v) {
        return v.options.every(function (o, i) { return o === sel[i]; });
      })[0];
    }

    picker() {
      var s = this.dataset.section;
      return document.querySelector('variant-radios[data-section="' + s + '"]') || document.querySelector('variant-selects[data-section="' + s + '"]');
    }

    liveVariants() {
      var p = this.picker();
      var node = p && p.querySelector('script[type="application/json"]');
      try { if (node) return JSON.parse(node.textContent); } catch (e) { /* usa los datos propios */ }
      return this.cfg.variants;
    }

    currentOptions() {
      var p = this.picker();
      if (p && p.tagName === 'VARIANT-RADIOS') {
        return Array.prototype.map.call(p.querySelectorAll('fieldset'), function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      if (p) return Array.prototype.map.call(p.querySelectorAll('select'), function (s) { return s.value; });
      return this.cfg.selected.slice();
    }

    applyOption(p, index, value) {
      if (p.tagName === 'VARIANT-RADIOS') {
        var fs = p.querySelectorAll('fieldset')[index];
        if (!fs) return;
        var input = Array.prototype.filter.call(fs.querySelectorAll('input[type="radio"]'), function (i) { return i.value === value; })[0];
        if (!input || input.checked) return;
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      } else {
        var sel = p.querySelectorAll('select')[index];
        if (!sel || sel.value === value) return;
        sel.value = value;
        sel.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    /* Enlace a la guía de tallas del producto (página GUIA DE TALLAS o tabla). */
    guideLink() {
      var self = this;
      var link = el('button', 'lsf-btn lsf-btn--ghost lsf-guide', this.t.view_table);
      link.type = 'button';
      link.addEventListener('click', function () {
        self.fbReturn = self.step;
        self.renderFallback(self.t.size_table);
        self.show('fallback');
      });
      return link;
    }

    /* ---------- Guía de tallas (y respaldo para productos sin tabla) ---------- */
    renderFallback(title) {
      var view = this.querySelector('[data-lsf-view="fallback"]');
      view.querySelector('[data-lsf-fb-title]').textContent = title;
      view.querySelector('[data-lsf-fb-text]').hidden = !!this.valid.length;
      var holder = view.querySelector('[data-lsf-tables]');
      holder.innerHTML = '';
      var self = this;
      var page = view.querySelector('[data-lsf-page]');
      if (page) page.hidden = false;
      /* La tabla generada solo se repite aquí si el producto no tiene página de guía propia. */
      if (this.valid.length && page) return;
      this.guides.forEach(function (g) {
        if (!g.table.rows.length || g.table.errors.length) return;
        holder.appendChild(self.table({ table: g.table, sizes: g.table.rows }, { key: '_fb' }));
      });
    }

    /* ---------- Privacidad: solo se guarda con consentimiento, en este navegador ---------- */
    restore() {
      try {
        var s = JSON.parse(localStorage.getItem(STORE) || 'null');
        if (s && s.body) {
          this.saved = true;
          this.body = s.body;
          if (s.fit) this.fit = s.fit;
          if (s.build) this.build = s.build;
        }
      } catch (e) { this.saved = false; }
    }
    persist() {
      var c = this.querySelector('[data-lsf-consent]');
      if (!c || !c.checked) return;
      try {
        localStorage.setItem(STORE, JSON.stringify({ body: this.body, fit: this.fit, build: this.build }));
        this.saved = true;
      } catch (e) { /* almacenamiento no disponible */ }
    }
    forget() {
      try { localStorage.removeItem(STORE); } catch (e) { /* nada */ }
      this.saved = false;
      var f = this.querySelector('[data-lsf-forget]');
      if (f) f.hidden = true;
    }
  }

  customElements.define('lonely-size-finder', LonelySizeFinder);
})();
